import {useEffect, useState} from "react";
import {getIntegrationsRequest} from "../../../services/api";

const useIntegrationsData = () => {
  const [integrationsInfo, setIntegrationsInfo] = useState({
    integrationsData: [],
    loading: true
  });

  useEffect(() => {
    getIntegrationsRequest()
      .then((response) => {
        setIntegrationsInfo({
          integrationsData: response.data,
          loading: false
        });
      });
  }, []);

  return integrationsInfo;
};

export default useIntegrationsData;